<template>
    <el-dialog
        :model-value="visible"
        :width="width || '500px'"
        :center="false"
        :class="isNoPadding ? 'nopadding-dialog-con' : (type === 'msg' || type === 'msg-error') ? 'msg-dialog-con' : 'resource-dialog-con'"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="appendToBody"
    >
        <template #header>
            <div class="dialog-header">
                <div :class="['title-con', {'msg-title-con': type === 'msg' || type === 'msg-error'}]">
                    <i v-if="type === 'msg'" class="iconfont icon-tishi info-icon"></i>
                    <i v-if="type === 'msg-error'" class="iconfont icon-guanbi1 error-icon"></i>
                    <div class="title-txt">{{ title }}</div>
                </div>
                <div v-if="type !== 'msg-error'" class="close-btn" @click="() => {emit('on-close')}">
                    <i class="iconfont icon-a-guanbidanchuang"></i>
                </div>
            </div>
        </template>
        <slot></slot>
    </el-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    visible: {
        type: Boolean,
        default: false
    },
    width: {
        type: [Number, String],
        default: '500px'
    },
    type: {
        type: String,
        default: ''
    },
    isNoPadding: {
        type: Boolean,
        default: false
    },
    appendToBody: {
        type: Boolean,
        default: false
    }
})
const emit = defineEmits(['on-close'])

const title = computed({
    get: () => {
        return props.title || ''
    },
    set: (val) => {
        return val
    }
})
const visible = computed({
    get: () => {
        return props.visible || false
    },
    set: (val) => {
        return val
    }
})

</script>

<style lang="scss" scoped>
.dialog-header {
    display: flex;
    justify-content: space-between;
    padding-left: 20px;
}
.title-con {
    display: flex;
    align-items: center;
    height: 54px;
    &.msg-title-con {
        margin-top: 10px;
        height: 44px;
    }
    .iconfont {
        font-size: 24px;
        margin-right: 6px;
        &.info-icon {
            color: #FF9201;
        }
        &.error-icon {
            color: #FF4719;
        }
    }
    .title-icon-img {
        width: 24px;
        height: 24px;
        margin-right: 5px;
    }
    .title-txt {
        // line-height: 54px;
        color: var(--color-black);
        font-size: 16px;
        font-weight: bold;
    }
}
.close-btn {
    width: 54px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
        .iconfont {
            color: var(--color-primary)
        }
    }
    .iconfont {
        color: var(--color-light-black);
        font-size: 12px;
    }
}
</style>
<style lang="scss">
.resource-dialog-con {
    .el-dialog__header {
        height: 54px;
        padding: 0;
        box-sizing: border-box;
        border-bottom: 1px solid var(--color-gray-auxiliary3);
        margin-right: 0;
    }
    .el-dialog__body {
        padding: 30px 20px 20px;
    }
}
.nopadding-dialog-con {
    .el-dialog__header {
        height: 54px;
        padding: 0;
        box-sizing: border-box;
        border-bottom: 1px solid var(--color-gray-auxiliary3);
        margin-right: 0;
    }
    .el-dialog__body {
        padding: 0;
    }
}
.msg-dialog-con {
    .el-dialog__header {
        height: 54px;
        padding: 0;
        box-sizing: border-box;
        margin-right: 0;
    }
    .el-dialog__body {
        padding: 0 20px 20px 50px;
    }
}
</style>